import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '网红爆料', path: '/category/wanghong-fancha' },
  { label: '明星八卦', path: '/category/mingxing-bagua' },
  { label: '独家揭秘', path: '/category/dujia-jiemi' },
  { label: '吃瓜社区', path: '/category/chigua-shequ' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-1 whitespace-nowrap">
            <span className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              爆瓜网
            </span>
            <span className="w-2 h-2 rounded-full bg-primary-500 ml-0.5 mt-1"></span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  isActive(item.path)
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className="hidden md:flex items-center gap-1.5 px-4 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors duration-200"
            >
              <i className="ri-user-line text-sm"></i>
              <span>关于我们</span>
            </Link>

            <button
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div
          ref={menuRef}
          className="md:hidden bg-background-50 border-t border-background-200/70"
        >
          <div className="px-4 py-3 flex flex-col gap-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap bg-foreground-950 text-background-50 text-center"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}